import React, { useState } from 'react';
import styles from './styles.module.scss';

export default function QuickActionButton({ label, icon, color, onClick }) {

    const [pressed, setPressed] = useState(false);

    const handlePress = () => {
        if(onClick) onClick();
    }

    return (
        <div className={`${styles.qa} ${pressed ? styles.pressed : ''}`}
        style={{
            backgroundColor: pressed ? color : `${color}1A`, // 10% opacity default
            '--pressed-bg': color,
          }}
            onClick={handlePress}
            onMouseDown={() => setPressed(true)}
            onMouseUp={() => setPressed(false)}
            onMouseLeave={() => setPressed(false)}
            onTouchStart={() => setPressed(true)}
            onTouchEnd={() => setPressed(false)}
        >
            <span className={styles.plus} style={{ color }}>+</span>
            <span className="text-center">{icon} {label}</span>
        </div>
    )
}